module.exports = __webpack_public_path__ + "img/rec_green.1f6728e0.png";